import React, { useState, Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Link, Navigate } from "react-router-dom";
import {
  Info,
  Zap,
  Target,
  Settings,
  Mic,
  BarChart2,
  HelpCircle,
} from "lucide-react";

import Layout from "./components/Layout";
import LandingPage from "./pages/LandingPage";
import TensionAnalyzerPage from "./pages/TensionAnalyzerPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";

const StringCoachPage = lazy(() => import("./pages/StringCoachPage")); // Lazy load

// App component with Router remains the same
function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rotas que usam o Layout */}
        <Route path="/" element={<Layout />}>
          {" "}
          {/* O Layout envolve as rotas filhas */}
          <Route index element={<LandingPage />} /> {/* Rota raiz '/' */}
          <Route path="analyzer" element={<TensionAnalyzerPage />} />{" "}
          {/* Rota '/analyzer' */}
          <Route path="privacy" element={<PrivacyPolicy />} />{" "}
          {/* Rota '/privacy' */}
          <Route
            path="coach"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <StringCoachPage />
              </Suspense>
            }
          />{" "}
          {/* Adicionar rota do Coach com code splitting */}
          {/* Redirecionar qualquer rota não encontrada para a landing page */}
          <Route path="*" element={<Navigate to="/" replace />} />
          {/* Adicione outras rotas que usarão o Layout aqui */}
        </Route>
        {/* Adicione rotas que NÃO usam o Layout aqui, se necessário */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
